import { currency, dateFormat } from '@/shared/format'
import { DELIVERY_STATUS_PENDING, DELIVERY_STATUS_IN_PROGRESS, DELIVERY_STATUS_DELIVERED, DELIVERY_STATUS_RETURNED } from '@/shared/delivery'
import productNotFound from '@/assets/product-not-found.png'

export function getOrdersCost (state) {
  return function (index) {
    const order = state.orders.orders[index]

    const productCost = getProductCost(order.products)
    const deliveryCost = order.delivery.cost

    return currency(productCost + deliveryCost)
  }
}

export function getOrderCost (state) {
  const order = state._order

  const productCost = getProductCost(order.products)
  const deliveryCost = order.delivery.cost

  return currency(productCost + deliveryCost)
}

export function getOrderProductsCost (state) {
  const products = state._order.products

  const cost = getProductCost(products)
  return currency(cost)
}

function getProductCost (products) {
  return products.reduce((cost, product) => {
    let price = product.price
    if (product.variant) {
      price = product.variant.price
    }

    return (parseFloat(price) * product.quantity) + cost
  }, 0)
}

export function getOrderProductCost (state) {
  return function (index) {
    const product = state._order.products[index]
    if (product.variant) {
      return currency(product.variant.price)
    }

    return currency(product.price)
  }
}

export function getOrderProductCoverImage (state) {
  return function (index) {
    const product = state._order.products[index]
    if (hasImages(product)) {
      return product.image_urls[0]
    }

    const productVariant = getProductVariant(product)
    if (productVariant && hasImages(productVariant)) {
      return productVariant.image_urls[0]
    }

    return getImageProductVariants(product.variants)
  }
}

function getProductVariant (product) {
  if (!product.variant || !product.variants || product.variants.length === 0) {
    return null
  }

  for (const variant of product.variants) {
    if (product.variant.name === variant.name) {
      return variant
    }
  }

  return null
}

function getImageProductVariants (variants) {
  if (!variants) {
    return productNotFound
  }

  for (const variant of variants) {
    if (hasImages(variant)) {
      return variant.image_urls[0]
    }
  }

  return productNotFound
}

function hasImages (product) {
  const images = product.image_urls

  return !!images && images.length > 0
}

export function getDeliveryByStatus (state) {
  const deliveryRecords = state._order.delivery_records
  if (!deliveryRecords) {
    return [{
      status: DELIVERY_STATUS_PENDING,
      details: [
        { creation_date: state._order.creation_date }
      ]
    }]
  }

  const deliveryRecordsByStatus = []
  for (const record of deliveryRecords) {
    const deliveryRecord = deliveryRecordsByStatus.find(element => element.status === record.status)
    if (deliveryRecord) {
      deliveryRecord.details.push({
        description: record.description,
        creation_date: record.creation_date
      })

      continue
    }

    deliveryRecordsByStatus.push({
      status: record.status,
      details: [{
        description: record.description,
        creation_date: record.creation_date
      }]
    })
  }

  return deliveryRecordsByStatus
}

export function getOrdersDeliveryLastRecord (state) {
  return function (index) {
    const order = state.orders.orders[index]

    const deliveryRecords = order.delivery_records
    if (!deliveryRecords || deliveryRecords.length === 0) {
      return null
    }

    const len = deliveryRecords.length

    return deliveryRecords[len - 1]
  }
}

export function getDeliveryLastRecord (state) {
  const deliveryRecords = state._order.delivery_records
  if (!deliveryRecords || deliveryRecords.length === 0) {
    return null
  }

  const len = deliveryRecords.length

  return deliveryRecords[len - 1]
}

export function getDeliveryLastStatus (state) {
  const lastRecord = getDeliveryLastRecord(state)
  if (!lastRecord) {
    return null
  }

  return lastRecord.status
}

export function getDeliveryTitle (state) {
  const record = getDeliveryLastRecord(state)
  if (!record || record.status === DELIVERY_STATUS_PENDING) {
    return 'Tu pedido en preparación'
  }

  if (record.status === DELIVERY_STATUS_IN_PROGRESS) {
    return 'Tu pedido en camino'
  }

  if (record.status === DELIVERY_STATUS_DELIVERED) {
    return 'Entregado el ' + dateFormat(record.creation_date, 'D [de] MMM')
  }

  if (record.status === DELIVERY_STATUS_RETURNED) {
    return 'Devuelto el ' + dateFormat(record.creation_date, 'D [de] MMM')
  }
}
